module.exports = __webpack_public_path__ + "static/media/fruits_53.0beef14b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_53.csv
// module id = 721
// module chunks = 0